export const ENV = {
  WatsonApiEndpoint: process.env.REACT_APP_WatsonApiEndpoint,
  ImageStaticEndpoint:
    process.env.STATIC_EndPoint || 'https://static-old.ajke.live/images/',
  ExcelDownloadEndpoint: process.env.REACT_APP_WatsonApiEndpoint_EXCEL,
};
